import FaqComponent from '@common/components/ConstellationFaqComponent';
import faqs from '@common/constants/faqs';

import { PAGE_BILLING_ADDRESS_ACH } from '../../pageFlows';

const FaqSection = ({ fromDashboard, currentPage }) => {
  let faqsContent = faqs.PAYMENT_INFO_RACHEL.body;
  if (currentPage === PAGE_BILLING_ADDRESS_ACH) {
    faqsContent = faqs.PAYMENT_INFO_RACHEL_BILLING_ADDRESS.body;
  }
  if (fromDashboard) {
    faqsContent = faqsContent.concat(faqs.EDIT_PAYMENT_INFO_RACHEL.body);
  }

  return <FaqComponent faqs={faqsContent} withBorder={!fromDashboard} />;
};

export default FaqSection;
